import { Navigate } from "react-router-dom";
import { IconWrapper } from ".";
import { ShoppingBagIcon } from "../../assets/icons";
import { selectUserCartItems } from "../../features/store/cartSlice";
import { useAppSelector } from "../../hooks/hooks";
import { getActiveUserId } from "../../pages/Cart/utils";
import { RootState } from "../../redux/store";

type CartProps = {
  darkMode: boolean;
};

export const CartButton = ({ darkMode }: CartProps) => {
  const { user } = useAppSelector((state) => state.auth);

  const userId = getActiveUserId(user);
  let itemCount = useAppSelector(
    (state: RootState) => selectUserCartItems(state, userId).length,
  );

  if (userId == "guest" && !user) itemCount = 0;

  return (
    <div className="relative inline-block">
      <IconWrapper>
        <ShoppingBagIcon theme={darkMode ? "dark" : "light"} />
      </IconWrapper>
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[11px] font-bold text-white bg-red-500 rounded-full border-2 border-white dark:border-[#121212] animate-scale-in">
          {itemCount > 99 ? "99+" : itemCount}
        </span>
      )}
    </div>
  );
};
